var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pet_transfer"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 298.75,
    cy: 300.97,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267,466.34,203.2,394l-56.29-63.83a39.72,39.72,0,0,1-10.21-26.55C136.7,282.78,153,263,177.12,263h54.1V185.67a64.84,64.84,0,1,1,129.68,0V263h56.39c24.13,0,40.42,19.83,40.42,40.69a39.72,39.72,0,0,1-10.21,26.55L391.21,394l-63.78,72.32A40.27,40.27,0,0,1,267,466.34Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetTransfer);
export default __webpack_public_path__ + "static/media/pet_transfer.870c8169e08fdb4efb486bf93da1c9c5.svg";
export { ForwardRef as ReactComponent };